module.exports = __webpack_public_path__ + "static/assets/84aefa938153e51579474dadf72c525b.png";